import { deprecate } from '../../../common/DeprecationService';

export const DocumentationLink = () =>
  deprecate('DocumentationLink', 'components/PF4/DocumentationLink', '3.18');
